export default __webpack_public_path__ + "static/media/rings-type-metal.7d41f85d.png";